import React from 'react';
import { IPage } from 'layouts/Navbar/Navbar.types';
import { NavLink } from 'react-router-dom';

import { Button } from '@mui/material';

interface NavbarLinkProps {
  page: IPage;
  color?: string;
}

const NavbarLink: React.FunctionComponent<NavbarLinkProps> = ({
  page,
  color = 'white',
}) => {
  return (
    <NavLink
      to={page.path}
      className={({ isActive }) => (isActive ? 'active-nav-link' : '')}
    >
      <Button sx={{ my: 2, color, display: 'block' }}>{page.label}</Button>
    </NavLink>
  );
};

export default NavbarLink;
